import { useLocation } from "react-router-dom";
import WhatsAppIcon from "./WhatsAppIcon";

// Phone number for WhatsApp - displayed as 01349941320 (BD local)
// wa.me requires international format without leading 0: 8801349941320
const WA_PHONE_INTL = "8801349941320";
const WA_PRESET_MESSAGE =
  "Hello CSB Pathway, I'd like to know more about studying abroad.";

const FloatingWhatsApp = () => {
  const location = useLocation();

  // Hide on admin routes
  if (location.pathname.startsWith("/cst")) return null;

  const waUrl = `https://wa.me/${WA_PHONE_INTL}?text=${encodeURIComponent(
    WA_PRESET_MESSAGE
  )}`;

  return (
    <a
      href={waUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      data-testid="floating-whatsapp-btn"
      className="fixed bottom-5 right-5 md:bottom-6 md:right-6 z-[150] group flex items-center"
    >
      {/* Tooltip — desktop only */}
      <span className="hidden md:inline-block mr-3 px-3 py-1.5 rounded-full bg-gray-900 text-white text-xs font-medium shadow-lg opacity-0 group-hover:opacity-100 translate-x-2 group-hover:translate-x-0 transition-all duration-300 whitespace-nowrap">
        Chat on WhatsApp
      </span>

      {/* Button with pulse ring */}
      <span className="relative flex h-14 w-14 md:h-16 md:w-16">
        <span
          className="absolute inline-flex h-full w-full rounded-full bg-green-500 opacity-60 animate-ping"
          style={{ animationDuration: "4s" }}
        />
        <span className="relative inline-flex h-full w-full items-center justify-center rounded-full bg-gradient-to-br from-green-500 to-green-600 shadow-xl ring-2 ring-white/50 hover:scale-110 active:scale-95 transition-transform duration-200">
          <WhatsAppIcon className="h-7 w-7 md:h-8 md:w-8 text-white" />
        </span>
      </span>
    </a>
  );
};

export default FloatingWhatsApp;
